// import jQuery from 'CommonScripts/jquery-1.10.2';
import isPageEditor from 'GlobalsScript/is-page-editor';
(function (window, document, $) {
     
    $(document).ready(function () {            

        /* Only register the collapsible code if the page isn't in edit mode*/
        if (!isPageEditor()) {
            //$.components.registerComponent('.collapsibleSpotEntry', function ($root) {
                var $root = document.querySelectorAll('.collapsibleSpotEntry');
                $root = $($root);
                var Collapsible = {
                    dom: {
                        base: $root,
                        trigger: $root.find('.collapsibleHeader'),
                        content: $root.find('.collapsibleContent')
                    },
                    set: {
                        speed: 400,
                        animating: false,
                        heightClosed: 0,
                        heightOpen: 0,
                        newHeight: null,
                        activeClass: 'opened'
                    },
                    fn: {
                        toggleContent: function (event) {
                            toggleCollapsibleContent(this, true);
                            event.preventDefault();
                        }
                    }
                },
                /* Add quick access variables to be used in local function
                 * Keep main variable name in case it needs to be shared with other JS files
                 */
                $dom = Collapsible.dom,
                $set = Collapsible.set,
                $fn = Collapsible.fn;

                $dom.trigger.on({
                    click: $fn.toggleContent
                });
            //});
        }

    });

})(window, document, jQuery);

function toggleCollapsibleContent(collapsibleEntry, animate) {
    jQuery(collapsibleEntry).find('.icon').toggleClass("active");
    var item = jQuery(collapsibleEntry).siblings(".collapsibleContent");
    if (item.is(':visible')) {
        if (animate) {
            item.slideUp();
        }
        else {
            item.hide();
        }
    }
    else {
        if (animate) {
            item.slideDown();
        }
        else {
            item.show();
        }
    }
}